export default "__VITE_ASSET__BVSsse6v__"